const part = [
    {
        path: 'sale-help-order',
        name: 'sale-help-order',
        meta: {
            icon: 'md-stats',
            title: '代下单',
            notCache: false,
            access: ['S', 'A', 'B', 'C', 'D', 'I', 'G', 'I2'],
            items: [
            ]
        },
        component: () => import('@/view/sale-management/sale-help-put-cart/sale-help-put-cart')
    }
];

export default part;
